/**
 * 這個檔案作為組件的目錄
 * 目的是統一管理對外輸出的組件，方便分類
 */
/**
 * 佈局組件
 */
import Footer from './Footer';
import { Question, SelectLang } from './RightContent';
import { AvatarDropdown, AvatarName } from './RightContent/AvatarDropdown';
import PrintNotice from './RightContent/PrintNotice';

export { AvatarDropdown, AvatarName, Footer, PrintNotice, Question, SelectLang };
